export enum DataLookupState {
  Loading,
  NoData,
  HasData
}
